import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MobileAiChatCard from '../components/MobileAiChatCard';
import { EndeavorApi } from '../../services/ApiService';

export default function MobileChatPage(){
  const { courseId } = useParams();
  const [courseName, setCourseName] = useState('');

  useEffect(() => {
    let ignore = false;
    async function loadCourse() {
      if (!courseId) return;
      try {
        const res = await EndeavorApi.getEndeavor(courseId);
        if (res?.ok) {
          const data = await res.json();
          if (!ignore) setCourseName(data?.name || '');
        }
      } catch {}
    }
    loadCourse();
    return () => { ignore = true; };
  }, [courseId]);

  // If courseId exists, use endeavor mode (locks docs to course context)
  return (
    <div className="m-screen">
      <MobileAiChatCard
        mode={courseId ? 'endeavor' : 'standard'}
        endeavorId={courseId ? Number(courseId) : null}
        endeavorName={courseName}
      />
    </div>
  );
}